// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"84448d70","796":"1351b67f"}[chunkId] + ".chunk.js";
};